import {writable} from 'svelte/store'

export type Settings = {
  facebook_key: string
  google_key: string
  hosts: string[]
}

export const settings = writable<Settings>({} as Settings)